import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Apollo, gql } from 'apollo-angular';
import { Button } from '@openng/optimus-ui/button';
import { DynamicDialogConfig, DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import { finalize } from 'rxjs';
import { AuthenticationService } from '~ngx-shared/authentication';

@Component({
  selector: 'app-education-user-agreement',
  templateUrl: './education-user-agreement.component.html',
  imports: [Button, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './education-user-agreement.component.css'
})
export class EducationUserAgreementComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly apollo = inject(Apollo);
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(DynamicDialogConfig);
  private readonly authenticationService = inject(AuthenticationService);

  readonly isPending = signal(false);

  accepted(): void {
    this.isPending.set(true);

    this.apollo
      .mutate({
        mutation: gql`
          mutation UpdateUserAgreement($user_agreement_accepted: Boolean = false, $id: bigint!) {
            result: update_education_${this.dialogConfig.data?.role}_data_by_pk(
              pk_columns: { id: $id }
              _set: { user_agreement_accepted: $user_agreement_accepted }
            ) {
              user_agreement_accepted
            }
          }
        `,
        variables: {
          id: this.dialogConfig.data?.id,
          user_agreement_accepted: true
        }
      })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.isPending.set(false))
      )
      .subscribe(mutationResult => {
        if (mutationResult?.error) {
          this.declined();
        } else {
          this.dialogRef.close(true);
        }
      });
  }

  declined(): void {
    this.authenticationService.signOut();
  }
}
